import { Box, Chip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { alpha, useTheme } from '@mui/material/styles';
import React from 'react';
import boddVariables from '../../variables.module.scss';

interface FilterButtonProps {
    filter: string;
    isSelected: boolean;
    onClick: (value: string) => void;
}

const FilterButton: React.FC<FilterButtonProps> = ({ filter, isSelected, onClick }) => {
    const theme = useTheme();
    return (
        <Chip
            label={(
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
                >
                    {filter}
                    <Box
                        ml={isSelected ? 1 : 0}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: isSelected ? 'content' : 0,
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        }}
                    >
                        <CheckIcon
                            fontSize="medium"
                            color="primary"
                            sx={{
                                width: isSelected ? 'max-content' : 0,
                                maxWidth: '1.5rem',
                                transform: isSelected ? 'scale(1)' : 'scale(0)',
                                opacity: isSelected ? 1 : 0,
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s',
                            }}
                        />
                    </Box>
                </Box>
            )}
            clickable
            onClick={() => onClick(filter)}
            size="medium"
            sx={{
                typography: 'body2',
                borderRadius: '32px',
                border: isSelected ? 'none' : `1px solid ${alpha(boddVariables.black, 0.26)}`,
                outline: isSelected ? `2px solid ${theme.palette.primary.main}` : 'none',
                transition: 'outline 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                backgroundColor: isSelected ? alpha(theme.palette.primary.main, 0.15) : 'transparent',
                my: 'auto',
                '&.Mui-focusVisible, &:focus': {
                    backgroundColor: isSelected ? alpha(theme.palette.primary.main, 0.15) : 'transparent',
                    outline: isSelected ? `2px solid ${theme.palette.primary.main}` : 'none',
                },
            }}
        />
    );
};

export default FilterButton;
